<template>
    <IFrameContainer v-if="isFeatureEnabled !== null"
        :dashboard="isFeatureEnabled ?  92: 7"
        :project="isFeatureEnabled ? 'foodics':'skylineDynamics'"/>
</template>

<script>

import IFrameContainer from '@/views/Admin/pages/Reports/components/IFrameContainer';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { Feature_Flags } from '@/enums/globals';
export default {
  name: 'ReportsLocations',
  components: {
    IFrameContainer,
  },
  data () {
    return {
      isFeatureEnabled: null,
    };
  },
  mounted () {
    const { isFeatureEnabled } = useFeatureFlags();
    this.isFeatureEnabled = isFeatureEnabled(Feature_Flags.METABASE_FOODICS_ALL_REPORTS);
    // eslint-disable-next-line no-undef
    analytics.track('view_locations_report', {});
  },
};
</script>
